(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(e){

  const btn = e.target.closest('.product-share-button');

  if(!btn) return;

  const url = window.location.origin + btn.dataset.shareUrl;

  const title = document.title;

  if(navigator.share){

    try{

      await navigator.share({
        title: title,
        url: url
      });

    }catch(err){}

  }else{

    try{

      await navigator.clipboard.writeText(url);

      alert('Product link copied!');

    }catch(err){

      prompt('Copy this link:', url);

    }

  }

});
  } catch(e) { console.error(e); }
})();

})();
